var map = {
	"./akrunow.jpg": 57,
	"./brickmagic.jpg": 58,
	"./gocode.jpg": 59,
	"./ikea-family.jpg": 60,
	"./kfc-delivery.jpg": 61,
	"./kfc-dinein.jpg": 62,
	"./lu7.png": 63,
	"./ouch.jpg": 64,
	"./smales.jpg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;